import { timeWindowUtils } from '@/utils'

import { BulkFieldValue } from '../../../../types'

import type { Texts } from './useTexts'

function isValidTimeWindow(
  timeWindow?: uui.domain.rm.TimeWindow,
  workingDayStartSec: number = 0,
): boolean {
  if (!timeWindow) return true

  const normalizedTw = timeWindowUtils.normalizeTimeWindow(timeWindow, workingDayStartSec)

  return timeWindowUtils.isValid(normalizedTw, workingDayStartSec)
}

export const createValidateTimeWindows = (
  texts: Texts,
  timeWindows: BulkFieldValue<[uui.domain.rm.TimeWindow?, uui.domain.rm.TimeWindow?]>,
  territory: uui.domain.client.rm.Territory,
) => {
  if (timeWindows) {
    const invalidTimeWindowIndexes =
      timeWindows.status === 'exact'
        ? timeWindows.value.reduce<number[]>((acc, tw, index) => {
            if (!isValidTimeWindow(tw, territory.workingDayStartSec)) {
              acc.push(index)
            }
            return acc
          }, [])
        : []

    const valid = invalidTimeWindowIndexes.length === 0

    if (!valid) {
      return texts.invalidTimeWindows
    }
  }
}
